import { makeStyles } from '@material-ui/styles';

export const homePageStyle = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('1080')]: {
      padding: '36px 0px 36px 0px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 32,
    },
  },
  image: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  section0: {
    alignItems: 'center',
  },
  section0_box: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 16,
    },
  },
  section1: {
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 32,
      marginBottom: 32,
    },
  },
  section2: {
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 32,
      marginBottom: 32,
    },
  },
  section3: {
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 32,
      marginBottom: 32,
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
  },
  section4: {
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: 32,
    },
  },
  section0_image: {
    width: '100%',
    marginTop: 48,
    [theme.breakpoints.down('xs')]: {
      marginTop: 36,
    },
  },
  section0_title: {
    fontSize: 48,
    marginBottom: 36,
    fontWeight: 500,
    lineHeight: '60px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 36,
      marginBottom: 24,
      lineHeight: '48px',
    },
  },
  section0_description: {
    fontSize: 20,
    lineHeight: '32px',
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      lineHeight: '26px',
    },
  },
  section1_image: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 16,
      width: 248,
      height: 248,
    },
  },
  section3_image: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 16,
      width: 248,
      height: 248,
    },
  },
  section1_title: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 16,
    lineHeight: '30px',
    [theme.breakpoints.down('md')]: {
      fontWeight: 500,
    },
  },
  section1_description: {
    fontSize: 18,
    lineHeight: '28px',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  section0_box_title: {
    width: 430,
  },
  mizbanWorkContainer: {
    marginTop: 36,
    marginBottom: 36,
    height: 89,
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      marginTop: 36,
      marginBottom: 36,
      height: 64,
    },
  },
  mizbanWork: {
    backgroundColor: theme.ui.tertiary,
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    width: '100%',
    height: 89,
    [theme.breakpoints.down('md')]: {
      height: 64,
    },
    display: 'flex',
  },
  mizbanWorkTitle: {
    fontWeight: 500,
    fontSize: 24,
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
    },
  },
}));
